const PAYMENT_FREQUENCIES = {
  hourly: "HOURLY",
  monthly: "MONTHLY",
};

export default PAYMENT_FREQUENCIES;
